import { Alert, Container, ContentLayout, Header, SpaceBetween, Button, Box } from '@cloudscape-design/components';
import BaseAppLayout from '@@/products/portal/components/base-app-layout';
import { useNavigate } from 'react-router-dom';

export default function InvalidInstancePage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    // Navigate to home page
    navigate('/portal');
  };

  const handleGoBack = () => {
    // Navigate back in history
    navigate(-1);
  };

  const content = (
    <ContentLayout
      header={
        <Header variant='h1' description='The instance you are trying to access does not exist'>
          Invalid Instance
        </Header>
      }
    >
      <Container>
        <SpaceBetween size='l'>
          <Alert type='error' header='Instance not found'>
            The requested instance could not be found. This may be because:
            <ul>
              <li>The instance name may be misspelled</li>
              <li>The instance may have been deleted or deactivated</li>
              <li>You might not have the necessary permissions to access this instance</li>
            </ul>
          </Alert>

          <Box>
            Please select a different instance from the dropdown menu, or contact your administrator if you believe this
            is an error.
          </Box>

          <SpaceBetween size='m' direction='horizontal'>
            <Button onClick={handleGoBack} variant='link' ariaLabel='Go Back'>
              Go Back
            </Button>
            <Button onClick={handleGoHome} variant='primary' ariaLabel='Go Home'>
              Go Home
            </Button>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </ContentLayout>
  );

  return <BaseAppLayout content={content} />;
}
